import './styles/graphic.scss';

import { select } from 'd3-selection';


export default function (props, container, isMobile) {
  const {
    initialWidth,
    initialHeight,
    // width,
    // height
  } = props;


  const status = select('#v-game-status');
  const scoreTeamOne = select('#v-score-team-one');
  const scoreTeamTwo = select('#v-score-team-two');
  const teamOneContainer = select('#v-team-one');
  const teamTwoContainer = select('#v-team-two');

  const draw = (data) => {
    scoreTeamOne.text(data.scoreboard.team_one.score);
    scoreTeamTwo.text(data.scoreboard.team_two.score);

    // console.log(data.scoreboard.game_progress.hasOwnProperty('header'));
    if (data.scoreboard.game_progress.hasOwnProperty('header')) {
      status.text(data.scoreboard.game_progress.header);
    } else if (data.scoreboard.game_progress.hasOwnProperty('primary')) {
      status.text(data.scoreboard.game_progress.primary);
      
    } else {
      status.text(data.scoreboard.status);
    }
  };


  const init = () => {
    const url = 'https://ix.cnn.io/data/super-bowl-58/score.json';
    fetch(url)
		  .then(res => res.json().then((data) => {
        		draw(data);
		  }));
	  };

  init();
  setInterval(init, 10000);
}
